module.exports = __webpack_public_path__ + "images/banner-27.cee0a1c2.jpg";